var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"91575d8be247482350616f758f8325438e6954fe"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["customer-frontend@linkgraph"]={id:"91575d8be247482350616f758f8325438e6954fe"};
      